/**
 * Create an object which does not include defined props
 * @source https://youmightnotneed.com/lodash/
 *
 * @param {*} obj
 * @param {*} props
 * @returns
 */
export default function omit(obj, props) {
	obj = { ...obj };
	props.forEach((prop) => delete obj[prop]);
	return obj;
}
